// Seed code for an ad-hoc route. `generate_route_instance_code` appends date and sequence on insert,
// so duplicate custom codes on one day are harmless (the second gets `-2`).

export const ADHOC_CODE_PREFIX = "HOC"

export const ADHOC_CODE_MAX_LENGTH = 8

/** Upper-cased letters/digits only: a hyphen would break the instance code's date-sequence suffix. */
export function normaliseAdhocCustomCode(input: string): string {
  return input
    .toUpperCase()
    .replace(/[^A-Z0-9]/g, "")
    .slice(0, ADHOC_CODE_MAX_LENGTH)
}

// Not unique within a second; the insert trigger's sequence makes a collision cosmetic.
function fallbackAdhocCode(now: Date): string {
  return String(now.getTime()).slice(-ADHOC_CODE_MAX_LENGTH)
}

export function buildAdhocRouteCode(customCode?: string | null, now: Date = new Date()): string {
  const custom = normaliseAdhocCustomCode(customCode ?? "")
  return `${ADHOC_CODE_PREFIX}-${custom || fallbackAdhocCode(now)}`
}

/** Seed only; the date and sequence are the trigger's to add. */
export function adhocRouteCodePreview(customCode: string): string {
  const custom = normaliseAdhocCustomCode(customCode)
  return custom ? `${ADHOC_CODE_PREFIX}-${custom}` : `${ADHOC_CODE_PREFIX}-…`
}
